module.exports = __webpack_public_path__ + "static/media/background.e330c89f.jpg";